// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2U4Ef","cell":"ColumnAccessor_cell__1eAkI","firstCellAccent":"ColumnAccessor_firstCellAccent__2u81r"};